export default "__VITE_ASSET__BkuVUXeQ__"